import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Aboutregistered = () => {
  return (
    <>
      <section className='about-info gray'>
        <Container>
          <Row className='align-items-center justify-content-between'>
            <Col md={12}>
              <div class="head-title mb-4 text-start"><div class="sup">FINTRAC</div><h2> <span class="text-gradient">Registered with FINTRAC</span></h2></div>
              <p>We are a registered canadian Money Services Business (MSB), compliant with the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC). Our registration number is M20666701.This ensures that our services meet the highest standards of security and regulatory compliance, providing you with the peace of mind that your transactions are in safe hands.</p>
              <p>At MyFX.ca, we pride ourselves on transparency, with no hidden fees or unexpected costs. Our user-friendly platform makes it easy to send money across borders in your preferred currency, while our experienced team offers personalized support to meet your specific financial needs.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Aboutregistered